import PROD_CONFIG from './config_prod';
import LOCAL_CONFIG from './config_local';
import TEST_CONFIG from './config_test';

let IS_PROD = false;
let IS_LOCAL = false;
let IS_TEST = false;

const uri = window.location.href;

if (uri.includes('localhost')) {
  IS_LOCAL = true;
}
/*
*  추후 base url 전체 로 변경해야함.
* */
if (uri.includes('perplay.bo.web.test.perplay.io')) {
  IS_TEST = true;
}
/*
*  추후 base url 전체 로 변경해야함.
* */
if (uri.includes('perplay.bo.web.perplay.io')) {
  IS_PROD = true;
}

const config = IS_LOCAL ? LOCAL_CONFIG : IS_PROD ? PROD_CONFIG : IS_TEST ? TEST_CONFIG : LOCAL_CONFIG;
export default config;
